module.exports = __webpack_public_path__ + "img/LogoVls.baf294fc.png";